document.addEventListener("DOMContentLoaded", function () {
  const lenisJS = "https://unpkg.com/lenis@1.3.15/dist/lenis.min.js";
  const lenisCSS = "https://unpkg.com/lenis@1.3.15/dist/lenis.css";
  const gsapJS = "https://cdn.jsdelivr.net/npm/gsap@3.9.1/dist/gsap.min.js";
  const scrollTriggerJS =
    "https://cdn.jsdelivr.net/npm/gsap@3.9.1/dist/ScrollTrigger.min.js";

  async function initStickyScroll() {
    await loadCSS(lenisCSS);
    await loadScript(lenisJS);
    await loadScript(gsapJS);
    await loadScript(scrollTriggerJS);
    await new Promise((res) => setTimeout(res, 300));

    if (typeof Lenis !== "function") {
      console.error("Lenis not loaded:", window.Lenis);
      return;
    }

    const lenis = new Lenis({ smooth: true, lerp: 0.1 });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    gsap.registerPlugin(ScrollTrigger);

    const popup = document.querySelector(".custom-prices");
    const triggerEl = document.querySelector(".product-details-right");
    if (!popup || !triggerEl) return;

    gsap.set(popup, { opacity: 0, x: "100%" });
    gsap.to(popup, {
      opacity: 1,
      x: "0%",
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: triggerEl,
        start: "top 30%",
        end: "max",
        toggleActions: "play reverse play reverse",
        scrub: false,
      },
    });
  }

  initStickyScroll().catch((err) =>
    console.error("Sticky scroll init error:", err)
  );

  // -----------------------------
  // UNIT PRICE LOGIC
  // -----------------------------

  const FINAL_PRICE_SELECTOR =
  ".custom-prices .final-price .product-pricing .price__current .money";
const UNIT_PRICE_SELECTOR =
  ".custom-prices .unit-price .product-pricing .price__current .money";
const COUNT_SELECTOR =
  '.cl-po--option[data-option="Count"] select.cl-po--input';

const LEFT_UNIT_PRICE_CONTAINER = ".product-details-left .unit_price";
const LEFT_UNIT_PRICE_TEXT = ".product-details-left .unit_price span.unit-price";

const MAX_RETRIES = 5;
let unitPriceRetryCount = 0;

function getNumericFromText(text) {
  if (!text) return 0;
  return (
    parseFloat(
      text.trim().replace(/[^0-9.,]/g, "").replace(/,/g, "")
    ) || 0
  );
}

function formatPrice(num) {
  return `$${num.toFixed(3)}`;
}

function updateUnitPrice() {
  const finalPriceEl = document.querySelector(FINAL_PRICE_SELECTOR);
  const unitPriceEl = document.querySelector(UNIT_PRICE_SELECTOR);
  const countSelect = document.querySelector(COUNT_SELECTOR);

  if (!finalPriceEl || !unitPriceEl || !countSelect) {
    console.warn(
      "updateUnitPrice: Missing final price, unit price, or count element."
    );
    return;
  }

  const count = parseFloat(countSelect.value.replace(/,/g, "")) || 0;
  const mainPrice = getNumericFromText(finalPriceEl.textContent);

  if (!count || !mainPrice) {
    console.log("updateUnitPrice: Missing count или main price.");
    return;
  }

  const unitValue = mainPrice / count;
  const truncated = Math.floor(unitValue * 1000) / 1000;
  const formatted = formatPrice(truncated);

  // Update RIGHT section (popup)
  unitPriceEl.textContent = formatted;

  // -----------------------------
  // NEW ➜ UPDATE LEFT SECTION
  // -----------------------------
  const leftContainer = document.querySelector(LEFT_UNIT_PRICE_CONTAINER);
  const leftUnitPriceText = document.querySelector(LEFT_UNIT_PRICE_TEXT);

  if (leftContainer && leftUnitPriceText) {
    // If hidden → unhide it
    if (leftContainer.classList.contains("visually-hidden")) {
      leftContainer.classList.remove("visually-hidden");
    }
    // Update text
    leftUnitPriceText.textContent = formatted;
  } else {
    console.warn("Left unit price container or text not found.");
  }

  console.log("Updated Unit Price:", formatted);
}

function scheduleCheckAndRetry() {
  const finalPriceEl = document.querySelector(FINAL_PRICE_SELECTOR);
  const unitPriceEl = document.querySelector(UNIT_PRICE_SELECTOR);
  if (!finalPriceEl || !unitPriceEl) return;

  setTimeout(function () {
    const finalNum = getNumericFromText(finalPriceEl.textContent);
    const unitNum = getNumericFromText(unitPriceEl.textContent);

    if (finalNum === unitNum && unitPriceRetryCount < MAX_RETRIES) {
      unitPriceRetryCount++;
      console.log(
        "Both prices match after update → retrying updateUnitPrice… Retry:",
        unitPriceRetryCount
      );
      updateUnitPrice();
      scheduleCheckAndRetry();
    }
  }, 120);
}

function triggerUnitPriceUpdate() {
  unitPriceRetryCount = 0;
  updateUnitPrice();
  scheduleCheckAndRetry();
}

// Initial run
triggerUnitPriceUpdate();

// Count changes
const countSelect = document.querySelector(COUNT_SELECTOR);
if (countSelect) {
  countSelect.addEventListener("change", triggerUnitPriceUpdate);
}

// Watch FINAL PRICE changes
const finalPriceEl = document.querySelector(FINAL_PRICE_SELECTOR);
if (finalPriceEl) {
  const observer = new MutationObserver(triggerUnitPriceUpdate);
  observer.observe(finalPriceEl, {
    childList: true,
    characterData: true,
    subtree: true,
  });
}
});
